import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper, StepperOrientation } from '@angular/material/stepper';
import { environment } from 'src/environments/environment';
import * as Constants from "../../../../constant/Constants";
import { IConfirmDialogData } from 'src/app/components/dialog/dialog.data';
import { map, Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { ApiCallService } from 'src/app/api/service/api-call.service';
import { ValidationService } from 'src/app/services/validation.service';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { ConfirmComponent } from 'src/app/components/dialog/confirm/confirm.component';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  @ViewChild('stepper') private stepper!: MatStepper;
  
  // Url Params
  claim: string = 'Accidental_damage';  // Windscreen, Other, Accidental_damage, theft ... etc.
  token: string = "placeholder-value"; // to validate the public accesses.
  // ++++++++++

  stepperIndex: number = 0;

  url: string = environment.baseUrl + Constants.claimDetailsURL;
  loading: boolean = false;

  minDobDate: Date;
  maxDobDate: Date;

  iSwearText: string = 'I hereby declare that these particulars are true, and undertake to forward immediately (if any, unanswered), correspondence relating to this accident.';

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  requiredString: string = 'This field is required';
  stepperOrientation: Observable<StepperOrientation>;

  formErrors:{[key:string]:string}= {
    location: '',
    date: '',
    time: '',
    description: '',
    otherDriver: '',
    driverName: '',
    injuries: '',
    othersInvolved: '',
    otherDetails: ''
  }
  validationMessages:{[key:string]:{[key:string]:string}}= {
    bank: {required: this.requiredString },
    location: {required: this.requiredString },
    date: {required: this.requiredString },
    time: {required: this.requiredString, futureTime: 'Incident time cannot be in the future' },
    description: {required: this.requiredString },
    otherDriver: {required: this.requiredString },
    driverName: {required: this.requiredString },
    injuries: {required: this.requiredString },
    othersInvolved: {required: this.requiredString },
    otherDetails: {required: this.requiredString }
  }

  // Step 2
  motorForm2 = this._formBuilder.group({
    isVehicleUse: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    vehicleUse: [''],

    isCarryingGoods: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    goodsDesc: [''],
    goodsOwner: [''],
    trailerRegMarks: [''],
    goodsWeight: [''],
  });
  // step 3
  motorForm3 = this._formBuilder.group({
    otherDriver: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    driverName: [''], // otherDriver
    driverID: [''], // otherDriver
    driverPhone: [''], // otherDriver
    driverDOB: [moment(null), Validators.nullValidator], // otherDriver
    driverOccupation: [''], // otherDriver
    driverEmployee: this._formBuilder.group({
      yes: false,
      no: true,
    }), // otherDriver
    driverPermission: this._formBuilder.group({
      yes: false,
      no: true,
    }), // otherDriver
    driverAdmitLiability: this._formBuilder.group({
      yes: false,
      no: true,
    }), // otherDriver
    driverExperience: [''], // otherDriver
    // Independent
    driverHasAccidents: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    driverAccidentNum: [''], // driverHasAccidents

    driverStatement: [''], // otherDriver
    // independent
    ownerStatement: [''],
  });
  // step 4
  motorForm4 = this._formBuilder.group({
    garageName: [''],
    garagePhone : [''],

    othersInvolved: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    others: this._formBuilder.array([]),

    hasPassengers: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    passengers: this._formBuilder.array([]),
    iSwear: [false]
  });

  constructor(
    private route: ActivatedRoute,
    private _formBuilder:FormBuilder,
    private validationService:ValidationService,
    public dialog: MatDialog,
    private apiCallService: ApiCallService,
    breakpointObserver: BreakpointObserver
  ) {
    const currentDate = new Date();
    const maxDob = new Date(currentDate.getTime());
    const minDob = new Date(currentDate.getTime());
    minDob.setFullYear(currentDate.getFullYear() - 150);
    maxDob.setFullYear(currentDate.getFullYear() - 18);

    this.minDobDate = minDob;
    this.maxDobDate = maxDob;

    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 200px)')
      .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params["token"] !== undefined ? params["token"] : Constants.tokenPlaceholderValue;

      if (params['claim'] !== undefined) {
        this.claim = params['claim'];
      }
    });

    this.motorForm3.valueChanges.subscribe((form) => {
      this.validationService.logValidationErrors(
        this.motorForm3,
        this.formErrors,
        this.validationMessages
      )

      if (form.driverPhone) {
        this.motorForm3.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          driverPhone: form.driverPhone.replace(/[a-z]/g, (match: string) => match.toUpperCase())
        }, {emitEvent: false});
      }
    });
  }

  logErrors() {
    this.validationService.logValidationErrors(
      this.motorForm2,
      this.formErrors,
      this.validationMessages
    )
    this.validationService.logValidationErrors(
      this.motorForm3,
      this.formErrors,
      this.validationMessages
    )
    this.validationService.logValidationErrors(
      this.motorForm4,
      this.formErrors,
      this.validationMessages
    )
  }
  
  // Add others involved
  createOthersFormGroup(): FormGroup {
    return this._formBuilder.group({
      regMark: [''],
      owner: [''],
      damages: [''],
      hasInjuries: this._formBuilder.group({
        yes: false,
        no: true,
      }),
      injuredPassengers: this._formBuilder.array([]),
    });
  };

  addNewOther() {
    const fields = this.motorForm4.get('others') as FormArray;
    fields.push(this.createOthersFormGroup());
    this.motorForm4.setControl('others', fields);
  }
  removeOther(i:number) {
    const fields = this.motorForm4.get('others') as FormArray;
    fields.removeAt(i);  
  }
  getOthers() : FormArray {  
    return this.motorForm4.get("others") as FormArray  
  }
  getOthersFormgroup(i: number) : FormGroup {  
    return this.getOthers().at(i) as FormGroup; 
  }
  // Add passengers in vehicle
  createPassengersFormGroup(): FormGroup {
    return this._formBuilder.group({
      name: [''],
      relationship: [''],
    });
  };
  addNewPassenger() {
    const fields = this.motorForm4.get('passengers') as FormArray;
    fields.push(this.createPassengersFormGroup());
    this.motorForm4.setControl('passengers', fields);
  }
  removePassenger(i:number) {
    const fields = this.motorForm4.get('passengers') as FormArray;
    fields.removeAt(i);  
  }
  getPassengers() : FormArray {  
    return this.motorForm4.get("passengers") as FormArray  
  }
  // Add injuries in vehicle
  createInjuriesFormGroup(): FormGroup {
    return this._formBuilder.group({
      name: [''],
    });
  };
  addInjured(index: number) {
    const fields = this.getOthers().at(index).get('injuredPassengers') as FormArray;
    fields.push(this.createInjuriesFormGroup());
  }
  removeInjured(index:number, j: number) {
    const fields = this.getOthersFormgroup(index).get('injuredPassengers') as FormArray;
    fields.removeAt(j);
  }
  getInjuries(index:number) : FormArray { 
    const otherGroup = this.getOthers().at(index) as FormGroup;
    return otherGroup.get('injuredPassengers') as FormArray;
  }

  onYesChange(
    formName: FormGroup,
    control: 'isVehicleUse' | 'isCarryingGoods' | 'otherDriver' | 'driverEmployee' | 'driverPermission' | 'driverAdmitLiability' | 'driverHasAccidents' | 'othersInvolved' | 'hasPassengers' | 'hasInjuries',
    index?: number
  ) {
    formName.get(control)?.get('no')?.setValue(false);
    formName.get(control)?.get('yes')?.setValue(true);

    switch(control) {
      case 'othersInvolved':
        if (this.getOthers().length === 0) {
          this.addNewOther();
        }
        break;
      case 'hasPassengers':
        if (this.getPassengers().length === 0) {
          this.addNewPassenger();
        }
        break;
      case 'hasInjuries':
        if (index !== undefined && this.getInjuries(index).length === 0) {
          this.addInjured(index);
        }
        break;
      default:
        break;
    }
    
  }
  onNoChange(
    formName: FormGroup,
    control: 'isVehicleUse' | 'isCarryingGoods' | 'otherDriver' | 'driverEmployee' | 'driverPermission' | 'driverAdmitLiability' | 'driverHasAccidents' | 'othersInvolved' | 'hasPassengers' | 'hasInjuries',
    index?: number
  ) {
    formName.get(control)?.get('yes')?.setValue(false);
    formName.get(control)?.get('no')?.setValue(true);

    switch(control) {
      case 'otherDriver':
        this.motorForm3.get('driverDOB')?.setValue(null);
        break;
      case 'othersInvolved':
        if (this.getOthers().length > 0) {
          for (let i = 0; i < this.getOthers().length; i++) {
            this.removeOther(i);
          }
        }
        break;
      case 'hasPassengers':
        if (this.getPassengers().length > 0) {
          for (let i = 0; i < this.getPassengers().length; i++) {
            this.removePassenger(i);
          }
        }
        break;
      case 'hasInjuries':
        if (index !== undefined && this.getInjuries(index).length > 0) {
          for (let i = 0; i < this.getInjuries(index).length; i++) {
            this.removeInjured(index, i);
          }
        }
        break;
      default:
        break;
    }

    if (control == 'otherDriver') {formName.get('driverName')?.setValue('');}
    else if (control == 'othersInvolved') formName.get('otherDetails')?.setValue('');
  }

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };
  
  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        runFunction();
      }
    });
  };

  // POST function
  postDataToWhatsapp = async () => {
    this.loading = true;
    try {
      let req: any = {
        ...this.motorForm2.value,
        ...this.motorForm3.value,
        ...this.motorForm4.value,
        token: this.token,
        filled: true,
      };

      if (req.driverDOB && req.driverDOB != '')
        req.driverDOB = (this.motorForm3.controls['driverDOB'].value)!.format("YYYY-MM-DD");

      if (req.date == 'Invalid date')
        req.date = '';
      if (req.driverDOB == 'Invalid date')
        req.driverDOB = '';

      // Update form data (POST)
      const response = await this.apiCallService.postRequest(
        `${this.url}`, req
      );
      
      if (!environment.production) console.log(":: Response data ::  ", response);

      if (response.error === false) {
        if (!environment.production) console.log("::: Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
      } else {
        if (!environment.production) console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      if (!environment.production) console.error('ERROR :: ', error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
  }

  submitForm(): void {
    switch (this.stepperIndex) {
      case this.stepper.steps.length-1:
        this.initDialogData(
          'Confirm submission',
          'Please proceed only if you have verified that the form details are correct',
          'Back',
          'Proceed'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
        break;
      default:
        this.navigateStepper('next')
        break;
    }
  }

  confirmCancel() {
    switch (this.stepperIndex) {
      case 0:
        this.initDialogData(
          'Warning',
          'Are you sure you want to cancel the application?',
          'back',
          'Cancel application'
        );

        this.showGenericPopup(this.cancelApplication);
        break;
      default:
        this.navigateStepper('previous')
        break;
    }
  }

  cancelApplication = async () =>  {
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);
      if (!environment.production) console.log(":: Response data ::  ", response);

      if (response.error === false) {
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
        
      } else {
        if (!environment.production) console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      if (!environment.production) console.error('ERROR :: ', error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL;
    }
  }
    
  onStepChange(event: StepperSelectionEvent) {
    this.stepperIndex = event.selectedIndex;
  }
  // Navigate steps
  navigateStepper(direction: 'next' | 'previous' | 'toIndex', index?: number): void {
    if (!this.stepper) return;

    try {
      switch (direction) {
        case 'next':
          this.stepper.next();
          break;
        case 'previous':
          this.stepper.previous();
          break;
        case 'toIndex':
          if (index !== undefined && index >= 0 && index < this.stepper.steps.length) {
            this.stepper.selectedIndex = index;
          }
          break;
        default:
          break;
      }
    } catch (error) {
      console.error('Error navigating stepper: ', error);
    }
  }

}
